import { combineReducers } from 'redux'
import DefaultReducers from 'reducers'
import { curate } from 'reducers/ops'
export default combineReducers({
  ...DefaultReducers,
  ops: combineReducers({
    curate,
  }),
})